import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cx } from "../../lib/cx";
import { dsControl } from "./styles";

export type ButtonVariant = "primary" | "secondary" | "link" | "icon";

type Props = {
  variant?: ButtonVariant;
  children?: ReactNode;
} & ButtonHTMLAttributes<HTMLButtonElement>;

/**
 * Pill button. Primary is amber with ink text. Icon is a 38px circle.
 * Labels are weight 600. Callers pass the visible label.
 */
export function Button({
  variant = "secondary",
  className,
  type = "button",
  children,
  ...rest
}: Props) {
  return (
    <button
      type={type}
      data-ds=""
      data-variant={variant}
      className={cx(
        dsControl,
        "inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap font-semibold",
        variant === "icon"
          ? "size-[38px] rounded-full bg-ds-glass p-0 text-ds-ink-2"
          : "h-[38px] rounded-ds-pill py-0",
        variant === "primary" &&
          "bg-ds-amber px-5 text-ds-item text-ds-on-amber shadow-ds-amber",
        variant === "secondary" &&
          "bg-ds-glass-strong px-[15px] text-ds-body text-ds-ink hover:bg-ds-amber hover:text-ds-on-amber",
        variant === "link" &&
          "bg-ds-glass-strong px-3 text-ds-body text-ds-teal hover:bg-ds-amber-soft hover:text-ds-on-amber",
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
}
